import { Property } from "./interfaces"

export const peso: Property = {
    title: "Peso",
    type: "integer"
}